// The story's sim side, with no browser-only imports (the Node tools build it too): the world addon that puts the
// story layer into the valley's kernel game (phase D joined: the default scene's). The townsfolk are the town's (their
// places, names and greetings by NPC id), the scenes the town's cutscenes (answering `story:scene`), the items, gold and
// shops the rpg layer's, and the facts all on one condition language.
import type { Conditions } from "@rpg/story";
import type { SpikeContent } from "../content";
import type { WorldAddon } from "../world/scene";
import type { GameEvents } from "../core";
import { readStoryContent, type StoryContent } from "./content";
import { createStoryLayer, type StoryLayer, type StoryNpcs, type StoryProviders, type StoryRpg } from "./module";
import { createQuestJournal } from "@rpg-unit/quest-journal";

/** The story's world addon and its layer. `scripts`: the compiled ink by name. */
export function storyScene(o: { content: SpikeContent; scripts: Readonly<Record<string, string>>; npcs: StoryNpcs; rpg: StoryRpg; conditions: Conditions; providers?: StoryProviders; story?: StoryContent }) {
  const content = o.story ?? readStoryContent(o.content.registry);
  let layer: StoryLayer | null = null;
  // the quest journal (@rpg-unit/quest-journal): its module hears story:quest; the notice listens through it
  const journal = createQuestJournal();
  const addon: WorldAddon = (parts) => {
    const l = createStoryLayer({
      content,
      scripts: o.scripts,
      text: (id) => o.content.t(id),
      world: parts.world,
      things: parts.things,
      thingsContent: parts.thingsContent,
      fight: parts.fight,
      nav: parts.nav,
      hero: () => {
        const h = parts.rig.hero();
        return { x: h.feet.x, y: h.feet.y, z: h.feet.z };
      },
      hours: () => parts.sky().hours(),
      day: () => parts.sky().state().clock.day,
      npcs: o.npcs,
      rpg: o.rpg,
      conditions: o.conditions,
      ...(o.providers ? { providers: o.providers } : {}),
    });
    layer = l;
    return {
      modules: [l.module, journal.module<GameEvents>()],
      build: (w) => l.build(w),
      hashed: [...l.hashed],
      pins: l.pins,
    };
  };
  return {
    addon,
    content,
    journal,
    layer: (): StoryLayer => {
      if (!layer) throw new Error("story: not set up yet");
      return layer;
    },
  };
}
